import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from './Input';
import { Button } from './Button';

export const AiKeyInput: React.FC<{
  value: string; onChange: (v: string) => void; placeholder?: string;
  onTest?: () => Promise<{ ok: true } | { ok: false; error: string }>;
}> = ({ value, onChange, placeholder, onTest }) => {
  const [show, setShow] = useState(false); const [busy, setBusy] = useState(false); const [result, setResult] = useState<string | null>(null);
  return (
    <div className="space-y-2">
      <div className="relative">
        <Input type={show ? 'text' : 'password'} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="pr-10" />
        <button type="button" onClick={() => setShow(s => !s)} className="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted">{show ? <EyeOff size={16} /> : <Eye size={16} />}</button>
      </div>
      {onTest && (
        <div className="flex items-center gap-2">
          <Button size="sm" variant="secondary" disabled={!value || busy} onClick={async () => {
            setBusy(true); setResult(null);
            try { const r = await onTest(); setResult(r.ok ? 'ok' : `failed: ${(r as { ok:false; error:string }).error}`); } finally { setBusy(false); }
          }}>{busy ? 'Testing…' : 'Test connection'}</Button>
          {result && <span className={`text-xs ${result === 'ok' ? 'text-success' : 'text-danger'}`}>{result}</span>}
        </div>
      )}
    </div>
  );
};
